// A SHOP's marketplace connection being unusable is not the staff member's
// session expiring. bo-api answers it with
//
//   424 errors.platform_token_unavailable    the shop's TikTok / LINE SHOPPING /
//                                            Pancake token is missing, unreadable
//                                            or its refresh failed
//   503 errors.platform_integration_disabled the integration is off in config
//
// and keeps 401 for an invalid / expired staff token only (403 access_denied
// for a missing role). Before that change these answered 401 and http.js
// logged the user out of BOTH bo-fn and seller-fn (shared .madamefin.com
// cookie). http.js now shows a toast for them and rejects, so the caller's own
// catch still runs.
//
// The body is the usual HttpResult with Error = [en, th], so no i18n key is
// needed to print the sentence.

export const PLATFORM_TOKEN_UNAVAILABLE = "errors.platform_token_unavailable";
export const PLATFORM_INTEGRATION_DISABLED = "errors.platform_integration_disabled";

const FALLBACK = {
    [PLATFORM_TOKEN_UNAVAILABLE]: [
        "The shop connection is unavailable (token missing or expired). Reconnect the shop in Platform settings and try again.",
        "การเชื่อมต่อร้านค้าใช้งานไม่ได้ (token หายหรือหมดอายุ) กรุณาเชื่อมต่อร้านค้าใหม่ในหน้าตั้งค่าแพลตฟอร์ม แล้วลองอีกครั้ง"
    ],
    [PLATFORM_INTEGRATION_DISABLED]: [
        "This platform integration is disabled.",
        "การเชื่อมต่อแพลตฟอร์มนี้ถูกปิดใช้งานอยู่"
    ]
};

function body(err) {
    return (err && err.response && err.response.data) || {};
}

// platformErrorCode(err) -> one of the two codes above, or "" when err is not a
// platform-connection error. 424 always counts (bo-api only uses it for this);
// 503 only with the matching code (503 also means schema_missing elsewhere).
export function platformErrorCode(err) {
    const st = err && err.response && err.response.status;
    const msg = body(err).Msg;
    if (st === 424) return msg === PLATFORM_INTEGRATION_DISABLED ? msg : PLATFORM_TOKEN_UNAVAILABLE;
    if (st === 503 && msg === PLATFORM_INTEGRATION_DISABLED) return msg;
    return "";
}

// platformErrorText(err, locale) -> the sentence to show: the server's
// Error[0] (en) / Error[1] (th), else the built-in fallback.
export function platformErrorText(err, locale) {
    const code = platformErrorCode(err) || PLATFORM_TOKEN_UNAVAILABLE;
    const idx = locale === "en" ? 0 : 1;
    const e = body(err).Error;
    if (Array.isArray(e) && typeof e[idx] === "string" && e[idx].trim()) return e[idx];
    return FALLBACK[code][idx];
}
